module.exports = __webpack_public_path__ + "static/shoe-layers-3-2231baa3bd7b0fa69928233b866e41ac.png";